import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class ProposalSlideSettingService extends BaseService {
  search = (data) =>
    this.axios.post(API_ENDPOINTS.PROPOSAL_SLIDE_SETTINGS_SEARCH, data);

  getDetail = ({ proposalSlideSettingId }) =>
    this.axios.get(
      API_ENDPOINTS.PROPOSAL_SLIDE_SETTING_DETAIL.replace(
        "{proposalSlideSettingId}",
        proposalSlideSettingId
      )
    );

  create = (data) =>
    this.axios.post(API_ENDPOINTS.PROPOSAL_SLIDE_SETTINGS_CREATE, data);

  update = (data) =>
    this.axios.put(
      API_ENDPOINTS.PROPOSAL_SLIDE_SETTING_UPDATE.replace(
        "{proposalSlideSettingId}",
        data.proposalSlideSettingId
      ),
      data
    );

  delete = ({ proposalSlideSettingId }) =>
    this.axios.delete(
      API_ENDPOINTS.PROPOSAL_SLIDE_SETTING_DELETE.replace(
        "{proposalSlideSettingId}",
        proposalSlideSettingId
      )
    );

  execute = ({ proposalSlideSettingId }) =>
    this.axios.post(
      API_ENDPOINTS.PROPOSAL_SLIDE_SETTING_EXECUTE.replace(
        "{proposalSlideSettingId}",
        proposalSlideSettingId
      )
    );
}
